export enum ScrollMode {
  UNKNOWN = -1,
  VERTICAL = 0, // Default value.
  HORIZONTAL = 1,
  WRAPPED = 2,
  PAGE = 3,
  INFINITE = 4,
}
